import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import HorizontalBarChart from "../../../ceo/analysis/competitive/charts/horizontal-bar";

class TeamReportsSection2Step7 extends PureComponent {
  get MarketShare() {
    const { teams, competition_metrics } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value:
          competition_metrics[team_id] &&
          competition_metrics[team_id]["MarketShare"]
            ? competition_metrics[team_id]["MarketShare"] * 100
            : 0
      });
    });

    return data;
  }

  get left_content() {
    return (
      <span>
        Market Share represents the percentage of total sales that your business
        has captured within a market within a period of time. It is calculated
        by taking your business sales and dividing it by the total of all sales.
        <br />
        <br />
        For example, if Apple sold 36 smartphones in 2017 and there were a total
        of 100 smartphones sold in 2017, then Apple held 36% market share (i.e.
        36% = 36/100).
        <br />
        <br />
        <div className="formula">
          MARKET SHARE =
          <div className="formula">
            YOUR UNIT SALES
            <hr />
            TOTAL INDUSTRY SALES
          </div>
        </div>
      </span>
    );
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <HorizontalBarChart suffix="%" data={this.MarketShare} />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Market Share
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Market Share"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step7;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-7.js